/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { DropDown2, DecimalInput } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_PREDICTIVE_TEXT } from "config";

export const OfferPurchaseTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const start = useInput("");
  const end = useInput("");
  const suffix = useInput("");
  const withCoupon = useInput("");
  const typeData = [
    { id: "", title: "" },
    { id: "or more", title: "or more" },
    { id: "or less", title: "or less" },
  ];

  const handleUpdateValue = (s, e, suf, withCpn) => {
    switch (suf) {
      case "or more":
        onChange(`w/purchase/$${s?.replace('$', '')} ${suf}${withCpn ? " w/" + withCpn : ""}`);
        end.setValue("");
        break;
      case "or less":
        onChange(`w/purchase/$${s?.replace('$', '')} ${suf}${withCpn ? " w/" + withCpn : ""}`);
        end.setValue("");
        break;
      case "":
        if (s && e) {
          onChange(`w/purchase/$${s?.replace('$', '')}-${e?.replace('$', '')}${withCpn ? " w/" + withCpn : ""}`);
          suffix.setValue("");
        } else if (s) {
          onChange(`w/purchase/$${s?.replace('$', '')}${withCpn ? " w/" + withCpn : ""}`);
          end.setValue("");
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (
      value &&
      value.startsWith("w/purchase/$") &&
      value.slice(12).length > 0
    ) {
      const main = value.slice(12);
      let quantityStr = main;
      let couponPart = "";

      if (main.includes(" w/")) {
        const parts = main.split(" w/");
        quantityStr = parts[0];
        couponPart = parts[1];
        withCoupon.setValue(couponPart);
      } else {
        withCoupon.setValue("");
      }
      
      if (quantityStr.endsWith("or more")) {
        suffix.setValue("or more");
        start.setValue(quantityStr.slice(0, quantityStr.length - 7).trim());
        end.setValue("");
      } else if (quantityStr.endsWith("or less")) {
        suffix.setValue("or less");
        start.setValue(quantityStr.slice(0, quantityStr.length - 7).trim());
        end.setValue("");
      } else {
        suffix.setValue("");
        if (quantityStr.includes("-")) {
          const parts = quantityStr.split("-");
          start.setValue(parts[0].trim());
          end.setValue(parts[1].trim());
        } else {
          start.setValue(quantityStr.trim());
          end.setValue("");
        }
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-1" style={{ fontSize: 13 }}>
          w/purchase/$
        </div>
        <div style={{ width: "100%", marginRight: 10, marginLeft: 10 }}>
          <DecimalInput
            label="Value Start"
            value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(e, end.value, suffix.value, withCoupon.value);
            }}
          />
        </div>
        <div style={{ width: "100%", marginRight: 10 }}>
          <DecimalInput
            label="Value End"
            value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(start.value, e, suffix.value, withCoupon.value);
            }}
          />
        </div>
      </Container>
      <Container>
        <div className="ml-auto" style={{ width: "30%" }}>
          <DropDown2
            label="Suffix"
            data={typeData}
            width={80}
            value={suffix.value}
            onChange={(e) => {
              suffix.setValue(e);
              handleUpdateValue(start.value, end.value, e, withCoupon.value);
            }}
          />
        </div>
        <div className="ml-auto" style={{ width: "50%" }}>
          <DropDown2
            label="w/Coupon"
            data={ALL_COUPON_TYPES_PREDICTIVE_TEXT}
            width={80}
            value={withCoupon.value}
            onChange={(e) => {
              withCoupon.setValue(e);
              handleUpdateValue(start.value, end.value, suffix.value, e);
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
